import React from 'react'

import { TextField, AlertWithActions } from '@masfront/common-b2c'
import { FastField, Field } from 'formik'

import { Box, MenuItem, Grid } from '@material-ui/core'

import useSignUpType from './useSignUpType'

import useNewLine from '../../hooks/useNewLine'
import useOperatorDonor from '../../hooks/useOperatorDonor'

export default function SignUpType({
  id,
  hasSelectedTariff,
}: {
  id: string
  hasSelectedTariff: boolean
}) {
  const { signUpTypes, portabilityTypes, isPortability, isNewProduct, lineNumber } = useSignUpType()

  const { type, text, actions } = useNewLine(isNewProduct, id)

  const { isOperatorLoading } = useOperatorDonor(isPortability, lineNumber, id)
  return (
    <Grid container component={Box} px={6} spacing={5}>
      <Grid xs={3} item>
        <Field
          disabled={!hasSelectedTariff}
          component={TextField}
          name="signUpType"
          variant="outlined"
          label="Tipo de alta"
          select
        >
          {signUpTypes.map(({ value, label }) => (
            <MenuItem value={value} key={value} data-hook={`sign-up-value-${id}-${value}`}>
              {label}
            </MenuItem>
          ))}
        </Field>
      </Grid>
      {isPortability && (
        <Grid item xs={7}>
          <Grid container spacing={5}>
            <Grid item xs={5}>
              <Field
                component={TextField}
                name="lineNumber"
                label="Número a portar"
                disabled={isOperatorLoading}
                variant="outlined"
                inputProps={{ maxLength: 9 }}
              />
            </Grid>
            <Grid xs={7} item>
              <FastField
                component={TextField}
                name="portabilityType"
                variant="outlined"
                label="¿Contrato o prepago? (donante)"
                select
              >
                {portabilityTypes.map(({ value, label }) => (
                  <MenuItem value={value} key={value} data-hook={`portabilityType-${value}`}>
                    {label}
                  </MenuItem>
                ))}
              </FastField>
            </Grid>
          </Grid>
        </Grid>
      )}
      {isNewProduct && (
        <Grid item xs={8}>
          <Box>
            {type !== 'error' ? (
              <AlertWithActions className={type} type={type} text={text} actions={actions} />
            ) : null}
          </Box>
        </Grid>
      )}
    </Grid>
  )
}
